import routerReferrer from '@shared/middlewares/routerReferrer';
import router from '@app/config/router';

export default routerReferrer({ router });
